export const PAGE_STATE = {
  CREATING: 'CREATING',
  UPDATING: 'UPDATING',
  SHOWING: 'SHOWING',
};
